import crews from "csi/access/crews";
import { ControllerInterface } from "csi/action/Controller";
import JsonResponse from "csi/comm/JsonResponse";
import { ControllerSaveFunction } from "csi/middleware/common";
import { resolveNode } from "csi/service/nodeService";
import { C8Node } from "csi/typings";
import { ILocaleProvider } from "designSystem/locale";
import CopyFoodStore from "./CopyFoodStore";

const PROJECT_EDIT_ROLES = ["Project Administrator", "Project Editor"];

/**
 * @param projectUrls 
 * @returns string[] with a blank option first
 */
async function getProjects(projectUrls: string[]): Promise<C8Node[]> {
	if (projectUrls.length === 0) {
		return [];
	}

	const projects: C8Node[] = await Promise.all(projectUrls.map(async (url: string) => {
		const projectLineItem: C8Node = await resolveNode(url);
		const project: C8Node = await resolveNode(projectLineItem?.__Parent__);
		return project;
	}));

	// checking and filtering for project create roles
	return crews.isInGlobalRoles(PROJECT_EDIT_ROLES) ? projects: projects.filter((project: C8Node) => {
		return crews.isInRoles(PROJECT_EDIT_ROLES, project);
	});
}

/** create copy food store */
export async function createCopyFoodStore(actionController: ControllerInterface, locale: ILocaleProvider, onSave: ControllerSaveFunction): Promise<CopyFoodStore> {
	const node: C8Node = actionController.getContext().getNode();
	const cache = actionController.getCache();
	const projects: C8Node[] = await getProjects(node.Projects);
	const onIncrementalSave: VoidFunction = (): void => {
		actionController.postProcessSuccess();
	};
	return new CopyFoodStore(locale, node, cache, onSave, onIncrementalSave, projects);
}
